"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const baseSelect_1 = __importDefault(require("./baseSelect"));
require("@hotmart/cosmos/dist/dropdown");
require("@hotmart/cosmos/dist/select");
const Select = ({ options, optionClassName, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(baseSelect_1.default, { ...rest, children: ({ getOptionOptionalProps }) => options === null || options === void 0 ? void 0 : options.map((option) => ((0, jsx_runtime_1.jsx)("hot-select-option", { value: option.value, class: optionClassName, role: "option", ...getOptionOptionalProps(option), children: option.label }, option.value))) }));
};
exports.default = Select;
